import http from "@/axios";
import {ChainDto, TaskOption} from "@/store/chain/types";
import {Player} from "@/store/player/types";
import PlayerStore from "@/store/player";
import {BankOption} from "@/store/shop/types";
import {HintDto} from "@/store/task/types";

export default class ChainStore {

    public static fetchChainInfo(chainId: number): Promise<ChainDto> {
        return http.get('/api/chain/' + String(chainId) + '/info')
            .then(r => r.data)
            .then(obj => {

                let elems: BankOption[] = [];

                for (let elem of obj.elements) {
                    if (elem.hasOwnProperty('countCurr')) {
                        elems.push(Object.assign(new TaskOption(), elem));
                    } else {
                        elems.push(Object.assign(new BankOption(), elem));
                    }
                }
                let res = new ChainDto();

                res.elements = elems;
                res.currentIndex = obj.currentIndex;
                res.title = obj.title;
                res.agitation = obj.agitation;

                return res;
            });
    }

    public static getTizer(chainId: number): Promise<HintDto> {
        return http.get('/api/chain/' + String(chainId) + '/tizer')
            .then(r => r.data)
            .then(hintObj => {
                return Object.assign(new HintDto(), hintObj);
            });
    }

    public static getCongratulation(chainId: number): Promise<HintDto> {
        return http.get('/api/chain/' + String(chainId) + '/congratulation')
            .then(r => r.data)
            .then(hintObj => {
                return Object.assign(new HintDto(), hintObj);
            });
    }

    public static takeFreeChainOption(chainId: number, optionId: string): Promise<Player> {
        return http.post('/api/chain/' + String(chainId) + '/free/' + String(optionId) + '/take')
            .then(r => r.data)
            .then(playerObj => {
                let player: Player = Object.assign(new Player(), playerObj);
                PlayerStore.SET_PLAYER(player);
                return player;
            });
    }

    public static setSeen(chainId: number): Promise<void> {
        return http.post('/api/chain/' + String(chainId) + '/mark/seen');
    }

}